import { render, staticRenderFns } from "./VendorCheck.vue?vue&type=template&id=3da5be19"
import script from "./VendorCheck.vue?vue&type=script&lang=js"
export * from "./VendorCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports